/**
 * FAB Link Tooltip
 * @class FABLinkTooltip
 * @static
 * @method get_tooltip_class
 * @method get_tooltip_styles
 */
export default class FABLinkTooltip {
  /**
   * Get tooltip class
   * @param {Object} styles
   * @returns {String}
   */
  static get_tooltip_class(styles) {
    let classNames = 'animate__animated animate__fadeIn text-md cursor-pointer ';

    // Add padding and shape class.
    if (styles.button.shape) {
      classNames += `px-4 pt-4 ml-3 rounded-md `;
    }

    return classNames;
  }

  /**
   * Get tooltip styles
   * @param {Object} styles
   * @param {Boolean} tooltipDisplay
   * @returns {String}
   */
  static get_tooltip_styles(styles, tooltipDisplay) {
    let tooltipStyles = '';

    // Set tooltip font color
    tooltipStyles += `color: ${styles.tooltip.font.color};`;

    // Set width if tooltip is not displayed
    if (!tooltipDisplay) {
      tooltipStyles += `width: auto;`;
    }

    // Set background color and height for shape template
    if (styles.button.shape) {
      tooltipStyles += `background-color: ${styles.button.color};`;
      tooltipStyles += `height: 80%;`;
    }

    return tooltipStyles;
  }
}
